import {ChangeDetectionStrategy, Component, ComponentRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {finalize} from 'rxjs/operators';
import {DataService} from '../services/data.service';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';
import {DialogCarComponent} from '../dialog-car/dialog-car.component';
import {Car} from '../models/api.models';

@Component({
    selector: 'app-airportcars',
    templateUrl: './airportcars.component.html',
    styleUrls: ['./airportcars.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AirportcarsComponent implements OnInit {

    @ViewChild('dialogsContainerAirport', {read: ViewContainerRef, static: true}) dialogsContainer;
    dialogRef: ComponentRef<DialogCarComponent>;

    sessionId?: string;
    airportCars: string[] = [];
    showNoCarsMessage = true;

    constructor(private restService: RestService,
                private uiBlockerService: UIBlockerService,
                private dataService: DataService) {
    }

    ngOnInit() {

        this.sessionId = this.dataService.getSessionIdentifier();

        this.makeTheAirportCarsRequest();

        this.dataService.dataChangedSession.subscribe(() => {

            this.sessionId = this.dataService.getSessionIdentifier();

            this.makeTheAirportCarsRequest();
        });
    }

    makeTheAirportCarsRequest() {
        if (!isNullOrUndefined(this.sessionId)) {
            this.getAirportCars();
        }
    }

    getAirportCars() {
        this.restService.getAirportCars()
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                })
            ).subscribe((res) => {
            if (this.dataService.isResponseSuccessful(res)) {
                this.airportCars = res.CarList || [];
                if (this.airportCars.length > 0) {
                    this.showNoCarsMessage = false;
                }
            }
        });
    }

    showCarDetails(carIdentifier: string) {
        this.showDialogForCar(carIdentifier);
    }

    showDialogForCar(carIdentifier: string) {
        const dialogTexts: { HeaderText: string; CarIdentifier: string } = {
            HeaderText: 'Car Details',
            CarIdentifier: carIdentifier
        };

        this.dialogsContainer.clear();
        this.dialogRef = this.dialogsContainer.createComponent(DialogCarComponent);

        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.carIdentifier = dialogTexts.CarIdentifier;
        this.dialogRef.instance.carItem = {CarIdentifier: dialogTexts.CarIdentifier} as Car;

        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            this.dialogRef.destroy();
        });
    }

}
